import { createFileRoute } from "@tanstack/react-router";

import { FbLandingPage } from "@/components/FbLandingPage";
import { FB_LANDING_VARIANTS } from "@/lib/fb-landing-variants";

export const Route = createFileRoute("/fb2")({
  head: () => ({
    meta: [
      { title: "Real Pranks — Exclusive Video" },
      {
        name: "description",
        content: "Watch a free exclusive RossCreations video and join Real Pranks.",
      },
    ],
  }),
  component: Fb2Page,
});

function Fb2Page() {
  return <FbLandingPage variant={FB_LANDING_VARIANTS.fb2} />;
}
